// Как найти среди услуг именно переводчика.
// Правильный способ — галочка «Это услуга переводчика» в админке (isTranslator).
// Если её ещё не проставили, подстраховываемся поиском по названию,
// чтобы цена в форме заявки не пропала.
const TRANSLATOR_WORDS = ["translat", "перевод", "аудармашы", "аударма"];

export const findTranslatorService = (services = []) => {
  const list = services || [];

  const flagged = list.find((s) => s?.isTranslator);
  if (flagged) return flagged;

  return list.find((s) =>
    Object.values(s?.name || {}).some(
      (value) =>
        typeof value === "string" &&
        TRANSLATOR_WORDS.some((word) => value.toLowerCase().includes(word))
    )
  );
};

// Услуги, прикреплённые к туру галочками в админке, в том же порядке,
// в каком они идут в списке услуг.
export const servicesForActivity = (services = [], activity) => {
  const ids = activity?.serviceIds || [];
  if (ids.length === 0) return [];
  return (services || []).filter((s) => ids.includes(s?._id));
};
